import { tw } from "@careinfo/tailwind";
import moment from "moment";
import { NotificationProps, TNotification } from "./types";

export function Notification({
  item,
  handleRead,
  handleNavigate = (item) => {},
  active,
}: Pick<NotificationProps, "handleRead" | "active" | "handleNavigate"> & {
  item: TNotification;
}) {
  const getFileName = (path: string) => {
    try {
      return decodeURIComponent(path.split("/").pop() || path);
    } catch {
      return path;
    }
  };
  return (
    <button
      type="button"
      onClick={() =>
        item?.unread ? handleNavigate(item) : console.log("read notification")
      }
      className={tw`text-left py-2 px-2  border-b-2  w-full focus:outline-none`}
    >
      <div className={tw`flex items-start justify-between w-full`}>
        <p key={item?.id} className={tw`text-sm font-medium  `}>
          {item?.title}
        </p>
        {active == "notification" && (
          <button
            key={item?.id}
            onClick={(e) => {
              e.stopPropagation();
              handleRead(item);
            }}
            className={tw`cursor-pointer  focus:outline-none block text-gray-600`}
          >
            {item.unread ? " Read " : "Unread"}
          </button>
        )}
      </div>
      <p>
        {item?.description?.startsWith("media/")
          ? getFileName(item.description)
          : item?.description}
      </p>
      <p className={tw`text-[10px] text-gray-500 opacity-60 py-1`}>
        {moment(item?.timestamp || item?.created).format(
          "YYYY-MM-DD hh:mm:ss A"
        )}
      </p>
    </button>
  );
}

export function Notice({ item, handleView }) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation(), handleView(item);
      }}
      className={tw`text-left py-2 px-2  border-b-2  w-full focus:outline-none`}
    >
      <div className={tw`flex items-start justify-between w-full`}>
        <p key={item?.id} className={tw`text-sm font-medium  `}>
          {item?.title}
        </p>
      </div>
      <p>{item?.description}</p>
      <p className={tw`text-[10px] text-gray-500 opacity-60 py-1`}>
        {moment(item?.timestamp || item?.created).format(
          "YYYY-MM-DD hh:mm:ss A"
        )}
      </p>
    </button>
  );
}

export function NotificationSkeleton() {
  return (
    <div
      className={tw`ml-2  animate-pulse  text-left py-2 px-2 border-b-2 space-y-2`}
    >
      <div className={tw`flex h-4  items-start justify-between gap-x-4`}>
        <div
          className={tw`text-sm h-3  bg-gray-200 font-medium  flex-1 rounded-md`}
        ></div>
        <div
          className={tw`cursor-pointer w-32 h-3 bg-gray-200  focus:outline-none block rounded-md text-gray-600`}
        ></div>
      </div>
      <div className="h-3  bg-gray-200 rounded-md"></div>
      <div
        className={tw`h-2 bg-gray-500 opacity-60 py-1 rounded-md w-1/3`}
      ></div>
    </div>
  );
}
